<template>
  <div class="print400List" id="dvData">
    <div align="center">
      <div class="printtitle">
        格林豪森物业
        <span>请修单</span>
      </div>
    </div>
    <table width="680" border="1" cellspacing="0" align="center">
      <tr>
        <td width="20" rowspan="3" align="center">
          客
          <br />户
          <br />助
          <br />理
          <br />填
          <br />写
        </td>
        <td width="70" align="center">客户姓名</td>
        <td width="100" colspan="1" align="center">
          <span v-if="this.form.user != null">{{this.form.user.nickName |valueIsNull}}</span>
          <span v-else>{{this.form.username |valueIsNull}}</span>
        </td>
        <td width="70" align="center">请修房号</td>
        <td width="180" colspan="3" align="center"   >
          <span v-if="this.form.garden.grids!= null">{{this.form.garden.grids.houseName}}-{{this.form.garden.grids.unitName}}-{{this.form.garden.grids.roomName}}</span>
        </td>
        <td width="70" align="center">联系电话</td>
        <td width="140" colspan="2" align="center">
          <span v-if="this.form.user != null">{{this.form.user.mobile |valueIsNull}}</span>
          <span v-else>{{this.form.mobile |valueIsNull}}</span>
        </td>
      </tr>
      <tr>
        <td rowspan="2" align="center">
          维修
          <br />内容
        </td>
        <td rowspan="2" colspan="7" class="printcontent">
          <div>{{this.form.content |valueIsNull}}</div>
        </td>
        <td width="70" align="center">相关费用</td>
      </tr>
      <tr>
        <td width="70" align="center">&nbsp;</td>
      </tr>
      <tr>
        <td width="20" rowspan="3" align="center">
          维
          <br />修
          <br />填
          <br />写
        </td>
        <td width="70" align="center">作业人员</td>
        <td colspan="3" rowspan="3">&nbsp;</td>
        <td width="70" align="center" rowspan="3">
          维修
          <br />结果
        </td>
        <td colspan="4" rowspan="3" valign="bottom">&emsp;作业人员：</td>
      </tr>
      <tr>
        <td width="70" align="center">到达时间</td>
      </tr>
      <tr>
        <td width="70" align="center">完工时间</td>
      </tr>
      <tr>
        <td width="20" align="center">
          客
          <br />户
          <br />填
          <br />写
        </td>
        <td width="70" align="center">
          维修
          <br />评价
        </td>
        <td colspan="3">
          <div class="manyi">
            <span>
              <i></i> 满意
            </span>
            <span>
              <i></i> 一般
            </span>
            <span>
              <i></i> 差
            </span>
          </div>
        </td>
        <td width="70" align="center">客户签名</td>
        <td colspan="4">&nbsp;</td>
      </tr>
      <tr>
        <td width="20" align="center">
          核
          <br />&nbsp;
          <br />验
        </td>
        <td width="70" align="center">
          核验
          <br />结果
        </td>
        <td colspan="3">&nbsp;</td>
        <td width="70" align="center">
          核验
          <br />人员
          <br />签字
        </td>
        <td colspan="4">&nbsp;</td>
      </tr>
    </table>
    <div class="line"></div>
    <div align="center">
      <div class="printtitle">
        格林豪森物业
        <span>请修单</span>
      </div>
    </div>
    <table width="680" border="1" cellspacing="0" align="center">
      <tr>
        <td width="20" rowspan="3" align="center">
          客
          <br />户
          <br />助
          <br />理
          <br />填
          <br />写
        </td>
        <td width="70" align="center">客户姓名</td>
        <td width="100" colspan="1" align="center">
          <span v-if="this.form.user != null">{{this.form.user.nickName |valueIsNull}}</span>
          <span v-else>{{this.form.username |valueIsNull}}</span>
        </td>
        <td width="70" align="center">请修房号</td>
        <td width="180" colspan="3" align="center">
          <span v-if="this.form.garden.grids!= null">{{this.form.garden.grids.houseName}}-{{this.form.garden.grids.unitName}}-{{this.form.garden.grids.roomName}}</span>
        </td>
        <td width="70" align="center">联系电话</td>
        <td width="140" colspan="2" align="center">
          <span v-if="this.form.user != null">{{this.form.user.mobile |valueIsNull}}</span>
          <span v-else>{{this.form.mobile |valueIsNull}}</span>
        </td>
      </tr>
      <tr>
        <td rowspan="2" align="center">
          维修
          <br />内容
        </td>
        <td rowspan="2" colspan="7">
          <div class="printcontent">{{this.form.content |valueIsNull}}</div>
        </td>
        <td width="70" align="center">相关费用</td>
      </tr>
      <tr>
        <td width="70" align="center">&nbsp;</td>
      </tr>
      <tr>
        <td width="20" rowspan="3" align="center">
          维
          <br />修
          <br />填
          <br />写
        </td>
        <td width="70" align="center">作业人员</td>
        <td colspan="3" rowspan="3">&nbsp;</td>
        <td width="70" align="center" rowspan="3">
          维修
          <br />结果
        </td>
        <td colspan="4" rowspan="3" valign="bottom">&emsp;作业人员：</td>
      </tr>
      <tr>
        <td width="70" align="center">到达时间</td>
      </tr>
      <tr>
        <td width="70" align="center">完工时间</td>
      </tr>
      <tr>
        <td width="20" align="center">
          客
          <br />户
          <br />填
          <br />写
        </td>
        <td width="70" align="center">
          维修
          <br />评价
        </td>
        <td colspan="3">
          <div class="manyi">
            <span>
              <i></i> 满意
            </span>
            <span>
              <i></i> 一般
            </span>
            <span>
              <i></i> 差
            </span>
          </div>
        </td>
        <td width="70" align="center">客户签名</td>
        <td colspan="4">&nbsp;</td>
      </tr>
      <tr>
        <td width="20" align="center">
          核
          <br />&nbsp;
          <br />验
        </td>
        <td width="70" align="center">
          核验
          <br />结果
        </td>
        <td colspan="3">&nbsp;</td>
        <td width="70" align="center">
          核验
          <br />人员
          <br />签字
        </td>
        <td colspan="4">&nbsp;</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {}
    }
  },
  created() {
    if (localStorage.getItem('form')) {
      this.form = JSON.parse(localStorage.getItem('form'))
    }
    setTimeout(() => {
      var printData = document.getElementById('dvData').innerHTML
      window.document.body.innerHTML = printData // 把 html 里的数据 复制给 body 的 html 数据 ，相当于重置了 整个页面的 内容
      window.print() // 开始打印
    }, 0)
  }
}
</script>
<style lang='scss'>
.print400List {
  width: 680px;
  margin: 0 auto;
  color: #000;
}
.printtitle {
  font-size: 14px;
  text-align: center;
  margin: 0;
  padding: 10px 0 10px;
}
.printtitle span {
  font-size: 12px;
  margin-left: 10px;
}
// .print400List table {
//   table-layout: fixed;
// }
// .print400List table td {
//   padding: 0;
// }
.manyi {
  text-align: center;
}
.manyi span {
  display: inline-block;
  line-height: 14px;
  margin-right: 10px;
}
.manyi i {
  display: inline-block;
  width: 10px;
  height: 10px;
  border: 1px solid #000;
  background: #fff;
}
.line {
  margin: 30px 0 30px;
  height: 1px;
  border-bottom: 1px dashed #000;
}
.printcontent {
  padding: 0 10px;
}
</style>